import { Link } from "react-router-dom";
import { SiteFooter, SiteNav } from "@/components/SiteChrome";
import { LEGAL_ENTITY, LEGAL_UPDATED } from "@/lib/legal";

const TABS = [
  ["/terms", "Terms & Conditions"],
  ["/privacy", "Privacy & NDPA"],
  ["/fees", "Fees & settlement"],
];

export const LegalPage = ({ title, intro, children, testId }) => (
  <div className="min-h-screen bg-stone-50">
    <SiteNav />
    <main className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8" data-testid={testId}>
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-emerald-700">Legal</p>
      <h1 className="mt-3 font-display text-4xl font-bold leading-tight text-slate-900 sm:text-5xl">{title}</h1>
      <p className="mt-4 text-base text-slate-600">{intro}</p>
      <p className="mt-2 text-xs text-slate-500">
        {LEGAL_ENTITY} · {LEGAL_UPDATED}
      </p>

      <nav className="mt-8 flex flex-wrap gap-2" data-testid="legal-tabs">
        {TABS.map(([to, label]) => (
          <Link
            key={to}
            to={to}
            className={`rounded-full border px-4 py-1.5 text-xs font-semibold transition-colors ${
              window.location.pathname === to
                ? "border-emerald-700 bg-emerald-900 text-white"
                : "border-slate-200 bg-white text-slate-600 hover:border-emerald-300"
            }`}
            data-testid={`legal-tab-${to.slice(1)}`}
          >
            {label}
          </Link>
        ))}
      </nav>

      <div className="mt-10 space-y-10">{children}</div>
    </main>
    <SiteFooter />
  </div>
);

export const Clause = ({ heading, paras = [], testId, children }) => (
  <section data-testid={testId}>
    <h2 className="font-display text-lg font-bold text-slate-900 md:text-lg">{heading}</h2>
    {paras.map((p) => (
      <p key={p.slice(0, 40)} className="mt-3 text-sm leading-relaxed text-slate-600">
        {p}
      </p>
    ))}
    {children}
  </section>
);
